// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { addListener } from "~/lib/signals";
import ContentFull from "~/content.full";
import { _ } from "~/i18n";
import { store } from "~/state/store";
import Canonical from "~/canonical";
import { isoZoneToUTC, dateToTime } from "~/util/format";

/**
 * Komponenta na zobrazovani zaznamu z webovych kamer v sirkach 2 a 3. Sourozenec od Mapy.Pano a Mapy.M3D.
 */
Mapy.Webcam = class extends ContentFull {
	constructor() {
		super();
		this._contentName = "webcam";
		this._dom = {
			container: node("div", {id:"webcam"}),
			title: node("h4")
		}

		this._buildCloseButton();
		addListener(this, "width-change-start", "_widthChangeStart");
		addListener(this, "width-change", "_widthChangeStop");
		addListener(this, "print-page", "_printPage");
		addListener(this, "print-done", "_printDone");

		this._printPromise = null;
	}

	setData(data, title) {
		this._dom.container.innerHTML = "";
		this._dom.title.innerHTML = _("webcam.title") + " - " + title;
		this._dom.container.appendChild(this._dom.title);
		this._sequenceData = data;
		this._buildWebcam();
		this._setSEO(title);
	}

	setState(state) {
		this["webcam" in state ? "activate" : "deactivate"]();
	}

	getState() {
		return {webcam:1};
	}

	activate() {
		if (this.isActive()) { return this; }

		this._appendCloseButton();

		Mapy.getComponent("layout").getScrollNode().addEventListener("scroll", this, false);
		window.addEventListener("resize", this, false);

		return super.activate();
	}

	deactivate() {
		if (!this.isActive()) { return this; }

		super.deactivate();

		this._removeCloseButton();

		window.removeEventListener("resize", this, false);
		Mapy.getComponent("layout").getScrollNode().removeEventListener("scroll", this, false);

		// vratime zpatky seo detailu
		Mapy.getComponent("detail").setSEO();

		return this;
	}

	handleEvent(e) {
		super.handleEvent(e);
		if (e.type == "scroll") {
			if (e.target.scrollTop > 0 && !this._dom.title.classList.contains("scroll")) {
				this._dom.container.classList.add("scroll");
				this._widthChange();
			}
			else if (e.target.scrollTop == 0 && this._dom.container.classList.contains("scroll")) {
				this._dom.container.classList.remove("scroll");
				this._dom.title.style.width = "";
				this._dom.title.style.right = "";
			}
		}

		if (e.type == "resize") {
			this._widthChange();
		}

		if(e.type == "click" && e.target.classList.contains("snapshot")) {
			this._showSequenceItem(e.target)
		}
	}

	_widthChangeStart(e) {
		if (Mapy.getComponent("print").isPrinting) { return; }
		if (e.data.newWidth < 2) { this.deactivate(); }
	}

	_widthChange() {
		if (this._dom.container.classList.contains("scroll")){
			var layout = Mapy.getComponent("layout"),
				body = layout.getBody(),
				scrollNode = layout.getScrollNode(),
				bodyW = body.offsetWidth;

			this._dom.title.style.width = (bodyW - 200) + "px";
			this._dom.title.style.right = (scrollNode.offsetWidth - bodyW) + "px";
		}
	}

	_buildWebcam() {
		this._dom.container.classList.add("content-media");
		this._dom.container.classList.add("sequence");

		this._dom.image = node("img", { crossOrigin: "anonymous" });
		this._dom.container.appendChild(this._dom.image);

		this._dom.snapshots = node("div");
		this._dom.snapshots.addEventListener("click", this, false);

		for (var i = 0, len = this._sequenceData.length; i < len; i++) {
			var data = this._sequenceData[i];
			var timeZone = Mapy.Util.testTimeZone(data["takeDate"] || data["createDate"]);
			var timeObj = timeZone ? isoZoneToUTC(data["takeDate"] || data["createDate"]) : new Date(data["takeDate"] || data["createDate"]);

			// zobrazime
			var item = node("div", {
				className: "snapshot",
				title: timeZone ? Mapy.Util.dateToLocaleFormat(timeObj, true) : Mapy.Util.dateToLocaleFormatLocal(timeObj, true),
				innerHTML: timeZone ? dateToTime(timeObj, false) : "<span>" +  Mapy.Util.dateToLocaleFormatLocal(timeObj, false) + "</span>" + timeObj.getHours().toString().lpad("0", 2) + ":" + timeObj.getMinutes().toString().lpad("0", 2)
			});
			this._dom.snapshots.appendChild(item);
		}
		this._dom.container.appendChild(this._dom.snapshots);

		this._showSequenceItem(this._dom.snapshots.firstChild); /* nejnovejsi */
	}

	_showSequenceItem(elm) {
		for (var i = 0, len = this._dom.snapshots.childNodes.length; i < len; i++) {
			if (elm == this._dom.snapshots.childNodes[i]) {
				var data = this._sequenceData[i];
				var photo = data.urls["default"] ? data.urls["default"] : null;

				if (photo) {
					this._dom.image.src = Mapy.CDN.setSize(photo, Mapy.CDN.SIZE_667_500);
				}
				elm.classList.add("active");
			} else {
				this._dom.snapshots.childNodes[i].classList.remove("active");
			}
		}
	}

	_setSEO (title) {
		const { data } = store.getState().detail;
		let type = data?.typeName ? " (" + data.typeName + ")" : "";

		if (data?.typeName === _("detail.content.typename")) {
			type = "";
		}

		Mapy.SEO.set(
			"{webcam} - {title}{type}".replace("{webcam}", _("webcam.title")).replace("{title}", title).replace("{type}", type ),
			_("detail.seo", {
				title: title,
				type: type
			})
		);

		Canonical.set("/", {
			source: data?.source,
			id: data?.id,
			webcam: 1
		});
	}

	/**
	 * Pokud se tiskne a panel JŘ se zmenšil, vyresolví se tisková promise (v dependencies tisku)
	 */
	_widthChangeStop() {
		if (!this.isActive()) { return; }
		if (Mapy.getComponent("layout").getWidth() < 2 && Mapy.getComponent("print").isPrinting) {
			this._printPromise.resolve();
			this._printPromise = null;
		}
	}

	/**
	 * Nastaví vyrobí tiskovou promisi, přidá ji do závislostí a spustí zmenšení plachty (aby v tisku nebyla malá mapa)
	 */
	_printPage() {
		if (!this.isActive() || Mapy.getComponent("print").mode === 4) { return; }
		this._printPromise = Mapy.Util.createPrintPromise();
		Mapy.getComponent("print").addDepends(this._printPromise);
		Mapy.getComponent("layout").setWidth(1);
	}

	/**
	 * Po dokončení printscreenování mapy nastaví šířku plachty opět na velkou
	 */
	_printDone() {
		if (!this.isActive()) { return; }
		Mapy.getComponent("layout").setWidth(2);
	}
};
